// Errors
export const ERR_INVALID_DATA = 'ERR_INVALID_DATA';
export const ERR_INVALID_PROVIDER = 'ERR_INVALID_PROVIDER';
export const ERR_UNAUTHORIZED = 'ERR_UNAUTHORIZED';
export const ERR_NO_USER_ID = 'ERR_NO_USER_ID';
export const ERR_UNCONFIRMED_EMAIL = 'ERR_UNCONFIRMED_EMAIL';
export const ERR_SERVER = 'ERR_SERVER';
export const ERR_EMAIL_ALREADY_USED = 'ERR_EMAIL_ALREADY_USED';
export const ERR_NOT_AVAILABLE = 'ERR_NOT_AVAILABLE';
